/*@ngInject*/
const UserGroupEditorRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadUserGroupActions = function (userGroupId) {
        let url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.user.UserGroup:' + userGroupId
                }
            };
        return this.get(url, config);
    };

    this.loadUserGroupById = function (userGroupId) {
        let url = '/rest/UserGroup/' + userGroupId;
        return this.get(url);
    };

    this.loadCarrierUserRoles = function () {
        let url = '/rest/UnderwritingUser/carrierUserRoleInfos';
        return this.get(url);
    };

    this.createUserGroup = function (userGroup) {
        let url = '/rest/UserGroup/createUserGroup';
        return this.post(url, userGroup);
    };

    this.saveUserGroup = function (userGroup) {
        let url = '/rest/UserGroup/';

        if (!_.isNil(userGroup.id)) {
            url += userGroup.id;
        }
        return this.post(url, userGroup);
    };
};

angular.module('umCore')
    .service('userGroupEditorRepository', UserGroupEditorRepository);
